import { render } from "./DetailVideoView.vue?vue&type=template&id=a727dddc&scoped=true&ts=true"
import script from "./DetailVideoView.vue?vue&type=script&lang=ts"
export * from "./DetailVideoView.vue?vue&type=script&lang=ts"

import "./DetailVideoView.vue?vue&type=style&index=0&id=a727dddc&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a727dddc"]])

export default __exports__